export enum AccordionStyle {
  primary = 'primary',
  secondary = 'secondary',
}
